import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* eslint-disable react-hooks/exhaustive-deps */
import { Icon, TableLoader } from '@livable/saas-react-components';
import { Accordion, AccordionDetails, AccordionSummary, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
// import { useLocation } from 'react-router-dom';
import { RESIDENCY_STATUS_KEY_VALUES } from 'src/constants/residency';
import FormerResidentTableRow from 'src/pages/ResidentsPage/FormerResidentTableRow';
import { useStore } from 'src/stores';
import { useDelay } from 'src/utils/hooks';
import useStyles from './styles';
export const FormerResidentsTable = observer(props => {
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const buildingId = props.buildingId,
    openResidentModal = props.openResidentModal,
    propertyId = props.propertyId,
    searchKey = props.searchKey;
  const isFinalStatementEstimationEnabled = store.account.featureFlagsStore.isFinalStatementEstimationEnabled;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    openedTables = _useState4[0],
    setOpenedTables = _useState4[1];
  const _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    units = _useState6[0],
    setUnits = _useState6[1];
  const handleAccordionChange = event => {
    const accordionId = event.currentTarget.id;
    if (!openedTables.includes(accordionId)) {
      setOpenedTables(prevValues => [...prevValues, accordionId]);
    } else {
      setOpenedTables(prevValues => prevValues.filter(prevValue => prevValue !== accordionId));
    }
  };
  const handleExpanderClick = () => {
    const tablesCount = units.length;
    const allTablesIds = units.map(row => row.id.toString());
    if (tablesCount > openedTables.length) {
      setOpenedTables([...allTablesIds]);
    }
    if (openedTables.length === tablesCount) {
      setOpenedTables([]);
    }
  };
  const getResidencies = async () => {
    const resp = await store.residencies.getAllResidenciesRelatedToSpecificBuildingAggregateAsync.run({
      buildingId,
      includeEmptyUnits: true,
      //!(searchKey && searchKey?.length > 0),
      searchQuery: searchKey,
      sortBy: 'Unitname',
      sortOrder: 'Asc',
      statuses: [RESIDENCY_STATUS_KEY_VALUES.FormerActive, RESIDENCY_STATUS_KEY_VALUES.FormerClosed]
    });
    return resp;
  };
  const getUnits = async () => {
    const resp = await store.units.getUnitsAsync.run({
      buildingId,
      applyToHomeDashboard: false
    });
    return resp;
  };
  const getResidenciesAccountData = async accountIds => {
    const resp = await store.account.getUsersProfilesAsync.run({
      accountIds
    });
    return resp;
  };
  const fetchResidencies = async () => {
    if (!buildingId) return;
    setIsLoading(true);
    const _await$Promise$all = await Promise.all([getResidencies(), getUnits()]),
      _await$Promise$all2 = _slicedToArray(_await$Promise$all, 2),
      residenciesRes = _await$Promise$all2[0],
      propertyUnitsRes = _await$Promise$all2[1];
    if (residenciesRes !== null && residenciesRes !== void 0 && residenciesRes.isSuccessful && propertyUnitsRes !== null && propertyUnitsRes !== void 0 && propertyUnitsRes.isSuccessful) {
      var _residenciesRes$respo, _residenciesRes$respo2;
      const propertyUnits = [...propertyUnitsRes.response];
      const buildingResidencies = residenciesRes === null || residenciesRes === void 0 || (_residenciesRes$respo = residenciesRes.response) === null || _residenciesRes$respo === void 0 ? void 0 : _residenciesRes$respo.buildingResidency;
      const residenciesAccountDataResp = await getResidenciesAccountData(residenciesRes === null || residenciesRes === void 0 || (_residenciesRes$respo2 = residenciesRes.response) === null || _residenciesRes$respo2 === void 0 ? void 0 : _residenciesRes$respo2.buildingResidency.filter(resident => typeof resident.residencyId === 'string' && typeof resident.accountId === 'string').map(i => i.accountId));
      if (residenciesAccountDataResp !== null && residenciesAccountDataResp !== void 0 && residenciesAccountDataResp.isSuccessful) {
        residenciesAccountDataResp === null || residenciesAccountDataResp === void 0 || residenciesAccountDataResp.response.forEach(account => {
          const buildingResidencyIndex = buildingResidencies.findIndex(buildingResidency => buildingResidency.accountId === account.id);
          if (buildingResidencyIndex !== -1) {
            buildingResidencies[buildingResidencyIndex].accountData = account;
          }
        });
        buildingResidencies.forEach(resident => {
          var _propertyUnits$proper, _propertyUnits$proper2;
          const propertyUnitIndex = propertyUnits.findIndex(unit => unit.id === resident.unitId && typeof resident.residencyId === 'string' && typeof resident.accountId === 'string');
          if (propertyUnitIndex !== -1 && Array.isArray((_propertyUnits$proper = propertyUnits[propertyUnitIndex]) === null || _propertyUnits$proper === void 0 ? void 0 : _propertyUnits$proper.units)) {
            propertyUnits[propertyUnitIndex].units.push(resident);
          }
          if (propertyUnitIndex !== -1 && !Array.isArray((_propertyUnits$proper2 = propertyUnits[propertyUnitIndex]) === null || _propertyUnits$proper2 === void 0 ? void 0 : _propertyUnits$proper2.units)) {
            propertyUnits[propertyUnitIndex] = Object.assign({}, propertyUnits[propertyUnitIndex], {
              units: [resident]
            });
          }
        });
      }
      if (searchKey && (searchKey === null || searchKey === void 0 ? void 0 : searchKey.length) > 0) {
        setUnits([...propertyUnits.filter(i => {
          var _i$units, _i$units2;
          if (i !== null && i !== void 0 && i.units && i !== null && i !== void 0 && (_i$units = i.units) !== null && _i$units !== void 0 && _i$units.length && (i === null || i === void 0 || (_i$units2 = i.units) === null || _i$units2 === void 0 ? void 0 : _i$units2.length) > 0) return true;
          const searchPhrase = new RegExp(searchKey, 'gi');
          // NOTE: just searching for empty unit name match
          return searchKey.length > 0 ? " ".concat(i.name).search(searchPhrase) > 0 : true;
        }).sort((a, b) => {
          return ('' + a.name).localeCompare(b.name, undefined, {
            numeric: true
          });
        })]);
      } else {
        setUnits([...propertyUnits.sort((a, b) => {
          return ('' + a.name).localeCompare(b.name, undefined, {
            numeric: true
          });
        })]);
      }
      await store.fse.getFSEInfosAsync.run({
        residencyIds: store.residencies.residenciesIdsByBuilding
      });
      setIsLoading(false);
      store.fse.setFSEBillIsSubmited(false);
    }
  };
  useDelay(() => fetchResidencies(), [searchKey], 1000);
  useEffect(() => {
    fetchResidencies();
  }, [buildingId]);
  useEffect(() => {
    if (store.fse.FSEBillIsSubmited) fetchResidencies();
  }, [store.fse.FSEBillIsSubmited]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.formerTableWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.formerTableContent
  }, isLoading || store.residencies.getAllResidenciesRelatedToSpecificBuildingV2Async.inProgress || store.residencies.getAllResidenciesRelatedToSpecificBuildingAggregateAsync.inProgress || store.units.getUnitsAsync.inProgress || store.account.getUsersProfilesAsync.inProgress ? /*#__PURE__*/React.createElement(TableLoader, null) : /*#__PURE__*/React.createElement(TableContainer, {
    className: classes.formerTenantsTable
  }, /*#__PURE__*/React.createElement(Table, {
    "aria-label": "former residents table",
    size: "small",
    className: classes.formerTable
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    className: classes.xsCell
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.generalExpander, " ").concat(openedTables.length > 0 ? classes.expanded : ''),
    onClick: handleExpanderClick
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-line-right"
  }))), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.smCell
  }, t('residencies_page.unit_name_cell')), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.smCell
  }, t('residencies_page.portal_access_cell')), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.residentCell
  }, t('residencies_page.former_resident_cell')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    className: classes.lgCell
  }, t('residencies_page.enrolled_date_cell')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    className: classes.lgCell
  }, t('residencies_page.move-out_date_cell')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    className: classes.mdCell
  }, t('residencies_page.occupancy_cell')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    className: classes.mdCell
  }, t('residencies_page.utility_enrolment')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    className: classes.mdCell
  }, t('residencies_page.last_statement_cell')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    className: classes.mdCell
  }, t('residencies_page.average_statement_cell')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    className: classes.mdCell
  }, t('residencies_page.current_balance_cell')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    className: classes.lgCell
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.toolboxWrapper
  }, /*#__PURE__*/React.createElement("span", null, t('residencies_page.action_toolbox_cell')))))))), !(isLoading || store.residencies.getAllResidenciesRelatedToSpecificBuildingV2Async.inProgress || store.residencies.getAllResidenciesRelatedToSpecificBuildingAggregateAsync.inProgress || store.units.getUnitsAsync.inProgress || store.account.getUsersProfilesAsync.inProgress) && !!units.length && units.map(tableRow => {
    var _tableRow$id, _tableRow$units, _tableRow$units2, _tableRow$units3, _tableRow$units4;
    return /*#__PURE__*/React.createElement(Accordion, {
      key: tableRow.id,
      className: classes.accordionWrapper,
      onChange: handleAccordionChange,
      expanded: openedTables.includes(tableRow === null || tableRow === void 0 || (_tableRow$id = tableRow.id) === null || _tableRow$id === void 0 ? void 0 : _tableRow$id.toString())
    }, /*#__PURE__*/React.createElement(AccordionSummary, {
      "aria-controls": "unit1-content",
      id: tableRow.id,
      expandIcon: /*#__PURE__*/React.createElement(Icon, {
        type: "arrow-line-right"
      })
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h5"
    }, "".concat(tableRow.name, ": ").concat((_tableRow$units = tableRow.units) !== null && _tableRow$units !== void 0 && _tableRow$units.length ? tableRow.units.length : 0, " former residents"))), /*#__PURE__*/React.createElement(AccordionDetails, null, ((_tableRow$units2 = tableRow.units) === null || _tableRow$units2 === void 0 ? void 0 : _tableRow$units2.length) > 0 && /*#__PURE__*/React.createElement(TableContainer, null, /*#__PURE__*/React.createElement(Table, {
      "aria-label": "statement table",
      size: "small",
      className: classes.formerTable
    }, /*#__PURE__*/React.createElement(TableBody, null, tableRow.units.map(unit => /*#__PURE__*/React.createElement(FormerResidentTableRow, {
      key: unit.accountId,
      isFinalStatementEstimationEnabled: isFinalStatementEstimationEnabled,
      openResidentModal: openResidentModal,
      propertyId: propertyId,
      row: unit,
      setFSEBillModalData: store.fse.setFSEBillModalData,
      propertyUtilities: store.properties.propertyUtilities
    }))))), (!((_tableRow$units3 = tableRow.units) !== null && _tableRow$units3 !== void 0 && _tableRow$units3.length) || ((_tableRow$units4 = tableRow.units) === null || _tableRow$units4 === void 0 ? void 0 : _tableRow$units4.length) === 0) && /*#__PURE__*/React.createElement("div", {
      className: classes.noUnits
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body1",
      color: "light"
    }, t('residencies_page.no_enrolled_resident')))));
  })));
});